import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { appHeightChanged } from '../../../actions/app-actions'
import Giftcard from './Giftcard'

class GiftcardState extends React.Component {
    constructor() {
        super();

        this.called = this.called.bind(this)
    }

    componentDidMount() {
        const { actions, iframeId } = this.props
       
        if (window.parent != window) actions.appHeightChanged(iframeId, false);
        else window.scrollTo(0, 0);
      

    }
    componentWillUnmount() {
        const { actions, iframeId } = this.props;
        if (window.parent != window) actions.appHeightChanged(iframeId, false);
        else sessionStorage.setItem("scroll-position", window.scrollY);
    }

    called() {
      
        if (window.parent != window) {
            const { actions, iframeId } = this.props;
            setTimeout(() => { actions.appHeightChanged(iframeId, false) }, 500); //Workaround for the duration it takes the DOM to rerender with the expanded element so we get the right height...
        }
    }

    render() {

        const { orgID } = this.props

        return (
            <Giftcard appHeightChanged={this.called} orgID={orgID} />
        )
    }
}

const mapStateToProps = (state, ownProps) => {


    return {
        orgID: state.organizer.id
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        actions: bindActionCreators(Object.assign({}, { appHeightChanged, }), dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(GiftcardState)